module.exports = __webpack_public_path__ + "f58e75143fdea6fb89d8f0d7bde26c59.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/whole_foods_2023_chart.png
// module id = 1754
// module chunks = 0